<template>
  <div>
    <v-btn dark block color="accent" @click.stop="closeClick">Close</v-btn>
    <v-list v-if="menu == 0">
      <v-list-tile value="true" two-line subheader v-for="(item, i) in items" :key="i" @click.stop.prevent="showMenu(i)">
        <v-list-tile-action> <v-icon v-html="item.icon"></v-icon> </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
          <v-list-tile-sub-title v-text="subtitles(item.subtitle)"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile value="true" @click.stop.prevent="logout()">
        <v-list-tile-action> <v-icon>exit_to_app</v-icon> </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <!-- Sub Menu -->
    <menu-projects v-if="menu == 1" :item="items[0]" @backToMenu="backToMenu"></menu-projects>
    <menu-pages v-if="menu == 2" :item="items[1]" @backToMenu="backToMenu"></menu-pages>
    <menu-account v-if="menu == 3" :item="items[2]" @backToMenu="backToMenu"></menu-account>
    <menu-settings v-if="menu == 4" :item="items[3]" @backToMenu="backToMenu"></menu-settings>

  </div>
</template>

<script>
import AppState from "../util/AppState";
import { FirebaseAuth } from "../firebase";

export default {
  components: {
    "menu-projects": () => import("./MenuProjects"),
    "menu-pages": () => import("./MenuPages"),
    "menu-account": () => import("./MenuAccount"),
    "menu-settings": () => import("./MenuSettings")
  },
  props: ["menu"],
  data() {
    return {
      items: [
        { icon: "folder", title: "Projects", subtitle: 1 },
        { icon: "web_asset", title: "Pages", subtitle: 2 },
        {
          icon: "account_circle",
          title: "Account",
          subtitle: FirebaseAuth.currentUser.email
        },
        { icon: "settings", title: "Project Settings", subtitle: 1 }
      ]
    };
  },
  methods: {
    subtitles(sub) {
      const cur =
        sub === 1 ? AppState.currentProject.title : AppState.currentPage.title;
      return sub === 1 || sub === 2 ? cur : sub;
    },
    logout() {
      this.$emit("logout");
    },
    showMenu(i) {
      this.$emit("showMenu", i);
    },
    closeClick() {
      this.$emit("closeClick");
    },
    backToMenu() {
      this.$emit("backToMenu");
    }
  }
};
</script>

<style>
.menu-item {
  margin: 10px 0;
  padding: 0 16px;
}
.sub-menu-wrapper {
  text-align: center;
}
.sub-menu-wrapper li.active {
  background-color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue